module.exports = __webpack_public_path__ + "static/truckster-logo@3x-885a1ee98cda379b16e92873a7d733c5.png";